// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_n0-1";
export var rowFirst = "_n0-3";
export var rowLast = "_n0-5";
export var rowMiddle = "_n0-4";
export var ticketListScroll = "_n0-2";
export var ticketStack = "_n0-0";